<template lang="pug">
div(class='-mr-2 flex items-center gap-2')
  span {{ $t('Die Applikation wurde aktualisiert und muss neu geladen werden.') }}
  btn(success icon='rotate-cw' class='mr-1' @click='reload') {{ $t('Neu laden') }}
</template>

<script setup lang="ts">
const reload = () => location.reload()
</script>
